import { Button, Modal } from 'antd';
import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useIntl } from 'umi';

const IconContainer = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
`;

interface MaintenanceModalProps {
  open: boolean;
  onCancel?: () => void;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  buttonText?: React.ReactNode;
  showButton?: boolean;
  closable?: boolean;
  maskClosable?: boolean;
}

const MaintenanceModal: React.FC<MaintenanceModalProps> = ({
  open,
  onCancel,
  title,
  subTitle,
  buttonText,
  showButton = true,
  closable = true,
  maskClosable = true,
}) => {
  const intl = useIntl();
  const lottieRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<any>(null);

  useEffect(() => {
    if (open && lottieRef.current) {
      if (animationRef.current) {
        animationRef.current.destroy();
      }

      animationRef.current = lottie.loadAnimation({
        container: lottieRef.current,
        loop: true,
        path: 'https://assets4.lottiefiles.com/packages/lf20_r0tkeuzo.json',
      });
    }

    return () => {
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, [open]);

  const resolvedTitle =
    title ??
    intl.formatMessage({
      id: 'pages.maintenance.title',
      defaultMessage: 'Under Construction',
    });
  const resolvedSubTitle =
    subTitle ??
    intl.formatMessage({
      id: 'pages.maintenance.subTitle',
      defaultMessage: 'This feature is currently under development. Please check back later.',
    });
  const resolvedButtonText =
    buttonText ??
    intl.formatMessage({
      id: 'pages.maintenance.gotIt',
      defaultMessage: 'Got it!',
    });

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={600}
      closable={closable}
      maskClosable={maskClosable}
      keyboard={closable}
    >
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <IconContainer>
          <div ref={lottieRef} style={{ width: 200, height: 200 }} />
        </IconContainer>
        <h2 style={{ margin: '20px 0 10px 0', fontSize: '24px' }}>{resolvedTitle}</h2>
        <p style={{ margin: '10px 0 30px 0', color: '#666', fontSize: '16px' }}>
          {resolvedSubTitle}
        </p>
        {showButton && (
          <Button type="primary" onClick={onCancel} size="large">
            {resolvedButtonText}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default MaintenanceModal;
